import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../Utils/api";
import {
  CREATE_SUPPORT_TICKET,
  GET_SUPPORT_TICKETS,
} from "../Action/actionTypes";
import {
  notifyError,
  notifySuccess,
} from "../../Utils/Helper";
import {
  createSupportTicketSuccess,
  createSupportTicketFailure,
  getSupportTicketsSuccess,
  getSupportTicketsFailure,
} from "../Action/supportTicketAction";

function* createSupportTicketRequest(actions) {
  try {
    const { payload } = actions;
    const { data } = yield call(API.post, "/support-ticket", payload.data);

    if (data?.meta?.code === 200 || data?.meta?.code === 201) {
      yield put(createSupportTicketSuccess(data?.data));
      notifySuccess("Ticket created successfully");

      if (payload?.callback) {
        yield call(payload?.callback, data);
      }
    } else {
      yield put(createSupportTicketFailure());
      notifyError(data?.meta?.message || "Failed to create ticket");
    }
  } catch (error) {
    yield put(createSupportTicketFailure());
    notifyError("Failed to create ticket");
  }
}

function* getSupportTicketsRequest(actions) {
  try {
    const { payload } = actions;
    const { data } = yield call(API.get, "/support-tickets");

    if (data?.meta?.code === 200) {
      yield put(getSupportTicketsSuccess(data?.data));

      if (payload?.callback) {
        yield call(payload?.callback, data);
      }
    } else {
      yield put(getSupportTicketsFailure());
    
    }
  } catch (error) {
    yield put(getSupportTicketsFailure());
    
  }
}

export function* watchCreateSupportTicketAPI() {
  yield takeEvery(CREATE_SUPPORT_TICKET, createSupportTicketRequest);
}

export function* watchGetSupportTicketsAPI() {
  yield takeEvery(GET_SUPPORT_TICKETS, getSupportTicketsRequest);
}

export default function* rootSaga() {
  yield all([watchCreateSupportTicketAPI(), watchGetSupportTicketsAPI()]);
}